module.exports = __webpack_public_path__ + "img/light_power.21ac17d9.png";